import { useEffect, useState } from "react";
import ShareModal from "../../modals/share/ShareModal";
import style from "./donation.module.css";
import { Helmet } from "react-helmet-async";
import useShareModal from "../../hooks/useShareModal";
import { useDispatch } from "react-redux";
import { getCenterById } from "../../apis/CenterApis";
import { Link, useNavigate } from "react-router-dom";

const DonationSucess = () => {
  const params = new URLSearchParams(window.location.search);
  const centerId = params.get("centerId");
  const type = params.get("type");
  const orderId =
    params.get("orderId") ||
    params.get("bookId") ||
    params.get("donationId") ||
    sessionStorage.getItem("last_book_order_id");

  const isBookDonation =
    type === "book-donation" ||
    type === "book_donation" ||
    type === "book" ||
    Boolean(orderId) ||
    sessionStorage.getItem("last_donation_page") === "/checkout" ||
    sessionStorage.getItem("is_book_donation") === "true";

  const navigate = useNavigate();
  const [centerData, setCenterData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (centerId) {
      dispatch(getCenterById({ id: centerId })).then((res) => {
        if (res?.centerData) {
          setCenterData(res.centerData);
        }
      });
    }
  }, [centerId, dispatch]);

  const {
    isOpen: showShareModal,
    shareConfig,
    openShareModal,
    closeShareModal
  } = useShareModal();

  const handleShare = () => {
    if (!centerData) return;

    const campaignUrl = `https://fundlife.me/donation/${centerData.slug || centerData._id}`;

    openShareModal({
      shareUrl: campaignUrl,
      title: centerData.centerName,
      description: centerData.description || "",
      pageId: centerData._id
    });
  };

  const handlenavigate = () => {
    navigate("/#newsletter-section");
  };

  return (
    <>
      <Helmet>
        <title>{isBookDonation ? "Order Confirmed - Fund Life" : "Success - Fund Life"}</title>
      </Helmet>

      {/* Hero Section */}
      <div className={style.donationsucesscontainer}>
        <div className="container">
          <div className={style.donationcontainertext}>
            <h1>{isBookDonation ? "Thank You for Sponsoring!" : "Thank You for Funding Life"}</h1>

            {/* Information Card - High contrast visible text & clean placement */}
            {isBookDonation && (
              <div className={style.successInfoCard}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  <span style={{ fontSize: "20px", lineHeight: "1.2" }}>✅</span>
                  <div>
                    <h3 className={style.infoTitle}>Thank you for sponsoring!</h3>
                    <p
                      className={style.infoMessageSmall}
                      style={{ color: "#1e293b", fontSize: "14px", lineHeight: "1.5", margin: 0 }}
                    >
                      A confirmation email with your order receipt has been sent to your email address.
                    </p>
                    {orderId && (
                      <p
                        className={style.infoOrderRefSmall}
                        style={{ color: "#475569", fontSize: "13px", margin: "6px 0 0" }}
                      >
                        Order Reference: <strong style={{ color: "#0f172a" }}>{orderId}</strong>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* 2 Buttons in ONE horizontal line */}
            <div className={style.sucessdonationbutton}>
              <button
                className={style.actionBtn}
                onClick={() =>
                  window.open("https://hbcuhopeproject.org/love-smarter-not-harder/", "_blank")
                }
              >
                Download "Love Smarter Not Harder"
              </button>

              <button
                className={style.actionBtn}
                onClick={() => window.open("https://admin.fundlife.me/", "_blank")}
              >
                Login to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Thank / Connect Section */}
      <div className={style.donationthankcontainer}>
        <div className="container">
          <div className={style.thankcontainertextp}>
            <h2 style={{ textAlign: "center", color: "#ffffff", fontWeight: "bold", margin: "0" }}>
              {isBookDonation
                ? "Your book sponsorship is directly shaping student futures."
                : "Your donation is helping to make a difference."}
            </h2>
            <h4 style={{ margin: "0", paddingTop: "20px" }}>Connect With Us</h4>
            <div className={style.socialIcons}>
              <Link to="https://www.facebook.com/fundlife.me" target="_blank">
                <img src="/facebook.png" alt="Facebook" />
              </Link>
              <Link to="https://www.instagram.com/fundlifeme/" target="_blank">
                <img src="/instagram.png" alt="Instagram" />
              </Link>
              <Link to="https://x.com/FundlifePages" target="_blank">
                <img src="/twitter.png" alt="Twitter" />
              </Link>
            </div>
            <div className={style.signUp}>
              <button onClick={handlenavigate}>Sign Up for Updates</button>
            </div>
          </div>
        </div>
      </div>

      <ShareModal
        show={showShareModal}
        onHide={closeShareModal}
        shareUrl={shareConfig?.shareUrl}
        title={shareConfig?.title}
        description={shareConfig?.description}
        pageId={shareConfig?.pageId}
      />
    </>
  );
};

export default DonationSucess;
